import { render } from "./SearchStake.vue?vue&type=template&id=88c5e740&scoped=true&ts=true"
import script from "./SearchStake.vue?vue&type=script&lang=ts"
export * from "./SearchStake.vue?vue&type=script&lang=ts"

import "./SearchStake.vue?vue&type=style&index=0&id=88c5e740&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c5e740"]])

export default __exports__